import {Avatar, Box} from '@material-ui/core'
import Styled from 'src/components/Styled'
import styles from './styles'
import _ButtonSmall from 'src/components/Buttons/ButtonSmall'

export const Root = Styled(Box, styles.root)
export const Thumbnail = Styled(Avatar, styles.thumbnail)
export const ButtonSmall = Styled(_ButtonSmall, styles.buttonSmall)
